import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import {
    PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
    BarChart, Bar, XAxis, YAxis, CartesianGrid
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AA336A", "#33AA99"];

const ChartPaper = ({ title, children }) => (
    <Paper style={{ padding: 16, height: 320, display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <div style={{ flex: 1, width: "100%", minHeight: 0 }}>
            <ResponsiveContainer>
                {children}
            </ResponsiveContainer>
        </div>
    </Paper>
);

const Charts = ({ charts }) => {
    return (
        <>
            <Grid container spacing={3}>
                {/* Tickets by Queue (Pie) */}
                <Grid item xs={12} md={4}>
                    <ChartPaper title="Tickets por Fila">
                        <PieChart>
                            <Pie
                                data={charts.ticketsByQueue}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={80}
                                fill="#8884d8"
                                label
                            >
                                {charts.ticketsByQueue.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color || COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ChartPaper>
                </Grid>

                {/* Tickets by Agent (Bar) */}
                <Grid item xs={12} md={4}>
                    <ChartPaper title="Tickets por Atendente">
                        <BarChart
                            data={charts.ticketsByAgent}
                            layout="vertical"
                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" />
                            <YAxis dataKey="name" type="category" width={100} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="value" name="Tickets" fill="#82ca9d" />
                        </BarChart>
                    </ChartPaper>
                </Grid>

                {/* Tickets by Channel (Pie) */}
                <Grid item xs={12} md={4}>
                    <ChartPaper title="Tickets por Canal">
                        <PieChart>
                            <Pie
                                data={charts.ticketsByChannel}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={40}
                                outerRadius={80}
                                fill="#82ca9d"
                                label
                            >
                                {charts.ticketsByChannel.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ChartPaper>
                </Grid>
            </Grid>
            {/* Bottom spacer to prevent cutoff */}
            <div style={{ height: '150px' }}></div>
        </>
    );
};

export default Charts;
